import { useEffect, useState } from 'react';
import AssignTableComp from '@components/Fireboard/components/AssignEmployee/TableView';
import { setErrorPopUp, setNotification } from '@reducers/notification';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';
import { getPopupConfig } from '@components/common/Popup/index';
import { useOutletContext } from 'react-router-dom';
import constant from '@components/common/globalization';
import {
  removeEmployeeAssignment,
  assignEmployee,
  getStationEmployees,
} from '@reducers/fireboard/assignEmployee.js';
import { getObjectValue } from '@utility/utills';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const AssignEmployee = props => {
  const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'));
  const stationEmpData = useSelector(
    state => state.assignEmployee.stationEmpData
  );
  const [activeTab, setActiveTab] = useState(constant.ALL);
  const [searchEmpval, setSearchEmpval] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [filteredEmpData, setFilteredEmpData] = useState([]);
  const [tableSearchVal, setTableSearchVal] = useState('');
  const [activeTable, setActiveTable] = useState();
  const [selectedEmp, setSelectedEmp] = useState();
  const { getPopup, setPopup } = useOutletContext();

  const storeInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('auth'), false)
  );

  const employeeData = stationEmpData?.employeeStations.sort((a, b) => {
    const nameA = a.employee?.firstName?.toLowerCase() || '';
    const nameB = b.employee?.firstName?.toLowerCase() || '';
    return nameA.localeCompare(nameB);
  });

  const tables = stationEmpData?.stationEmployees.sort((a, b) => {
    const numA = a?.station?.number ?? '';
    const numB = b?.station?.number ?? '';
    return numA.localeCompare(numB, undefined, {
      numeric: true,
    });
  });
  const revenueCenters = storeInfo?.revenueCenters;

  useEffect(() => {
    getPopup('spinner');
    props
      .getStationEmployees({ storeId: deviceInfo?.storeId })
      .then(() => setPopup(null))
      .catch(error =>
        props.setErrorPopUp({
          res: error.message,
        })
      );
  }, []);

  useEffect(() => {
    if (!tables) return;
    let filtered = tables;

    if (activeTab === constant.ASSIGNED) {
      filtered = filtered.filter(x => x.employees.length > 0);
    } else if (activeTab === constant.UNASSIGNED) {
      filtered = filtered.filter(x => x.employees.length === 0);
    }

    if (tableSearchVal?.trim()) {
      const value = tableSearchVal.toLowerCase();
      filtered = filtered?.filter(station => {
        return (
          station?.station?.number?.toLowerCase().includes(value) ||
          station.station?.revenueCenterName?.toLowerCase().includes(value)
        );
      });
    }

    setFilteredData(filtered);
  }, [stationEmpData, activeTab, tableSearchVal]);

  useEffect(() => {
    let employeesData = employeeData;
    if (searchEmpval.trim()) {
      const value = searchEmpval.toLowerCase();
      employeesData = employeesData.filter(({ employee }) => {
        const firstName = employee?.firstName || '';
        const lastName = employee?.lastName || '';
        const posId = employee?.posId || '';
        return (
          firstName.toLowerCase().includes(value) ||
          lastName.toLowerCase().includes(value) ||
          posId.toLowerCase().includes(value)
        );
      });
    }
    setFilteredEmpData(employeesData);
  }, [stationEmpData, searchEmpval]);

  // setting first table selected
  useEffect(() => {
    setActiveTable(stationEmpData?.stationEmployees?.[0]);
  }, [filteredData]);

  const onFilterChange = data => {
    setTableSearchVal('');
    setActiveTab(data);
  };

  const onDeleteTable = (emp, station) => {
    const callback = () => {
      getPopup('spinner');
      const data = {
        employeeId: emp?.id,
        stationId: station?.id,
        storeId: deviceInfo?.storeId,
      };
      props
        .removeEmployeeAssignment(data)
        .then(() => {
          setPopup(null);
          props.setNotification({
            type: 'success',
            message: FLABEL().TOAST_DELETE_EMPLOYEE,
          });
        })
        .catch(error =>
          props.setErrorPopUp({
            res: error.message,
          })
        );
    };
    const popup = getPopupConfig('success');
    popup.heading = FLABEL().ASSIGN_EMPLOYEE_DELETE_EMPLOYEE;
    popup.message = FLABEL()
      .ASSIGN_EMPLOYEE_DELETE_EMPLOYEE_MESSAGE.replace(
        '{{EmployeeName}}',
        emp.firstName || emp.firstName || emp.posId
      )
      .replace('{{TableNo}}', station.name);

    popup.buttons = [
      {
        btnType: 'cancel',
        text: FLABEL().ASSIGN_EMPLOYEE_NO,
        onClick: () => {
          setPopup(null);
        },
      },
      {
        btnType: 'submit',
        text: FLABEL().ASSIGN_EMPLOYEE_YES,
        onClick: () => {
          callback();
        },
      },
    ];
    setPopup(popup);
  };

  const onAssignEmp = () => {
    const callback = () => {
      getPopup('spinner');
      const data = {
        employeeId: selectedEmp?.id,
        stationId: activeTable?.station?.id,
        storeId: deviceInfo?.storeId,
      };
      props
        .assignEmployee(data)
        .then(() => {
          setPopup(null);
          setSelectedEmp(null);
          props.setNotification({
            type: 'success',
            message: FLABEL().TOAST_ASSIGN_EMPLOYEE,
          });
        })
        .catch(error =>
          props.setErrorPopUp({
            res: error.message,
          })
        );
    };
    const empName = `${selectedEmp?.firstName ?? ''} ${selectedEmp?.lastName ??
      ''}`;
    const tableName =
      activeTable?.station?.name ?? activeTable?.station?.number ?? '';
    const popup = getPopupConfig('success');
    popup.heading = FLABEL().ASSIGN_EMPLOYEE_ASSIGN_EMPLOYEE;
    popup.message = FLABEL()
      .ASSIGN_EMPLOYEE_ASSIGN_EMPLOYEE_MESSAGE.replace(
        '{{EmployeeName}}',
        empName
      )
      .replace('{{TableNo}}', tableName);

    popup.buttons = [
      {
        btnType: 'cancel',
        text: FLABEL().ASSIGN_EMPLOYEE_NO,
        onClick: () => {
          setPopup(null);
        },
      },
      {
        btnType: 'submit',
        text: FLABEL().ASSIGN_EMPLOYEE_YES,
        onClick: () => {
          callback();
        },
      },
    ];
    setPopup(popup);
  };

  return (
    <>
      <AssignTableComp
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        searchEmpval={searchEmpval}
        setSearchEmpval={setSearchEmpval}
        filteredData={filteredData}
        activeTable={activeTable}
        setActiveTable={setActiveTable}
        onFilterChange={e => onFilterChange(e)}
        onAssignEmp={onAssignEmp}
        onDeleteTable={onDeleteTable}
        revenueCenters={revenueCenters}
        filteredEmpData={filteredEmpData}
        setTableSearchVal={setTableSearchVal}
        tableSearchVal={tableSearchVal}
        setSelectedEmp={setSelectedEmp}
        selectedEmp={selectedEmp}
      />
    </>
  );
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setErrorPopUp,
      setNotification,
      getStationEmployees,
      removeEmployeeAssignment,
      assignEmployee,
    },
    dispatch
  );
export default connect(null, mapDispatchToProps)(AssignEmployee);
